import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component.js"
import useUpdatedEvent from "@kaspernj/api-maker/build/use-updated-event.js"

const PropTypes = require("prop-types")
const propTypesExact = require("prop-types-exact")

class EventUpdated extends ShapeComponent {
  static defaultProps = {
    active: true,
    debounce: false
  }

  static propTypes = propTypesExact({
    active: PropTypes.bool,
    debounce: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.number
    ]),
    model: PropTypes.object.isRequired,
    onConnected: PropTypes.func,
    onUpdated: PropTypes.func.isRequired
  })

  setup() {
    // Optional props are read from this.props (where useShapeHook has
    // merged defaultProps) because the strict this.p proxy throws on
    // props that were not passed.
    const {active, debounce, model, onConnected, onUpdated} = this.props

    // ShapeComponent's setup() is a documented React hook location
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useUpdatedEvent(model, onUpdated, {active, debounce, onConnected})
  }

  render() {
    return null
  }
}

export default React.memo(shapeComponent(EventUpdated))
